export const focusOption = (list, option) => {
    if (!option) {
        return;
    }
    if (list) {
        // eslint-disable-next-line no-param-reassign
        list.scrollTop = option.offsetTop - option.clientHeight * 2;
    }
    option.focus();
};
//# sourceMappingURL=focusOption.js.map